import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import CountdownOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('countdown', {
  template: require('./template.html'),
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    getSets() {
      // This is only for display purposes,
      // the jQuery plugin will read this and render
      return this.getSetString();
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzCountdown-clock' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        perspective: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        endLetterSpace: null,
        innerRadiusTopRight: null,
        innerRadiusTopLeft: null,
        innerRadiusBottomRight: null,
        innerRadiusBottomLeft: null,
        'letter-spacing': null,
        'font-size': null,
        'border-top-right-radius': null,
        'border-top-left-radius': null,
        'border-bottom-right-radius': null,
        'border-bottom-left-radius': null,
        'box-shadow': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  name: 'countdown',
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    CountdownOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzCountdown-clock',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
  },
  mounted() {
    this.callCssGenerator();
    $(document).ready(this.bindPlugin);
    this.observeVisibility();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    updateSetString() {
      this.$store.dispatch('setNewDropletValues', {
        drp: this.droplet,
        vm: this,
        values: [{
          key: 'setsString',
          value: this.getSetString(),
        }],
      });
    },
    getSetString() {
      const clock = _.cloneDeep(this.droplet.clock);
      const sets = clock.sets.map((set) => {
        // build date / time
        const date = new Date(set.endDate.date);
        const min = parseInt(set.endTime.mm, 10);
        const hr = parseInt(set.endTime.HH, 10);
        date.setMinutes(min);
        date.setHours(hr);
        date.setSeconds(0);
        // build buffer
        let buffer = false;
        if (set.bufferTime !== 0) {
          buffer = `${set.bufferTime} ${set.bufferDur}`;
        }
        return {
          end: date.toString(),
          buffer,
          endMessage: set.endMessage,
          recurring: set.recurring,
        };
      });
      return JSON.stringify({ sets });
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    bindPlugin() {
      const $countdown = $(this.$refs.drzCountdown);
      $countdown.drzCountDown();
    },
    unBindPlugin() {
      const $countdown = $(this.$refs.drzCountdown);
      $countdown.drzCountDown.reset();
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/countdown/index.js